import { createCompositionRootUI } from "./createCompositionRootUI";
import { router } from "./router/NavigateExporter";

const searchParams = new URLSearchParams(window.location.search);
const databaseIdsFromURLParams = searchParams.getAll("setDb");
const currencyFromURLParam = searchParams.get("currency") ?? undefined;
const removeSetDbParamsFromURL = () => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.delete("setDb");
    const newSearch = currentParams.toString();
    const newPath = newSearch
        ? `${window.location.pathname}?${newSearch}`
        : window.location.pathname;
    window.history.replaceState({}, "", newPath);
};
removeSetDbParamsFromURL();

export const {
    store,
    queryClient,
    ViewAuthInit,
    ViewFileUpload,
    ViewCoAUpload,
    ViewFileExtractionModal,
    ViewBreadcrumbs,
    ViewDatabaseSelector,
    ViewDealList,
    ViewDashboard,
    ViewDealCreation,
    ViewDealOverview,
    ViewDealDetails,
    ViewDealActivities,
    ViewToasts,
    ViewExtractionSidebar,
    ViewExtractionStandardizedSidebar,
    ViewSettingsMenu,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
    ViewDatabaseGuard,
    ViewSelectDatabaseModal,
    ViewUserConsentModal,
    ViewAuthCallback,
    ViewAuthGuard,
    ViewThirdPartyDoc,
    ViewExtraction,
    ViewExtractionReview,
    ViewExportModal,
    ViewUserPolicies,
    ViewCreateChartOfAccounts,
    ViewChartsOfAccountsDashboard,
    ViewEditChartOfAccountsDefinition,
    ViewEditChartOfAccountsDetails,
    ViewChartsOfAccountsDetails,
    ViewAuthRoleGuard,
    ViewChartsOfAccountsMappings,
    ViewChartsOfAccountsAuditLog,
    ViewExtractionAnnualized,
    ViewExtractionAnnualizedOptions,
    ViewExtractionAnnualizedAdditionalOptions,
    ViewProjectDocuments,
} = createCompositionRootUI({
    setDatabaseIdsOnAuthenticated: databaseIdsFromURLParams,
    currencyFromURLParam,
    router,
});
